import './App.css';
import './index.css';
import AppRouter from './router/AppRouter';
import CombinedProvider from './context/CombinedProvider';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    document.getElementById('initial-loader')?.remove();
    window.NativeBridge?.onLoadComplete?.();
  }, []);

  /**
   * Required to calculate vh unit and set it as the height of the document
   * Without this, there's an empty space when keyboard is open on ios spaces
   * causing the user to overscroll.
   */
  useEffect(() => {
    const updateVH = () => {
      try {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      } catch (error) {
        // Silently fail if CSS custom property setting fails
        console.warn('Failed to set --vh CSS custom property:', error);
      }
    };

    window.addEventListener('resize', updateVH);
    updateVH(); // initial run

    return () => {
      window.removeEventListener('resize', updateVH);
    };
  }, []);

  return (
    <CombinedProvider>
      <AppRouter />
    </CombinedProvider>
  );
}

export default App;
